namespace Nobox.NoBoxCRM {
    export interface FormSetting {
        Type: Serenity.EnumEditor;
        Payment: Serenity.Extensions.StaticTextBlock;
        SuccessType: Serenity.EnumEditor;
        SuccessData: Serenity.StringEditor;
        SuccessDataContainer: Serenity.Extensions.StaticTextBlock;
        FollowUp: Serenity.Extensions.StaticTextBlock;
        IsSendWa: Serenity.BooleanEditor;
        accWa: Serenity.ServiceLookupEditor;
        toWa: Serenity.StringEditor;
        IsSendMail: Serenity.BooleanEditor;
        accMail: Serenity.ServiceLookupEditor;
        toMail: Serenity.StringEditor;
        IsSendURL: Serenity.BooleanEditor;
        DataSendURL: Serenity.StringEditor;
        ShowLabel: Serenity.BooleanEditor;
        ShowCaptcha: Serenity.BooleanEditor;
        ShowCoupon: Serenity.BooleanEditor;
        Up: CustomDateTimeEditor;
        UpBy: Serenity.ServiceLookupEditor;
    }

    export class FormSetting extends Serenity.PrefixedContext {
        static formKey = 'NoBoxCRM.FormSetting';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FormSetting.init)  {
                FormSetting.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.Extensions.StaticTextBlock;
                var w2 = s.StringEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.ServiceLookupEditor;
                var w5 = CustomDateTimeEditor;

                Q.initFormType(FormSetting, [
                    'Type', w0,
                    'Payment', w1,
                    'SuccessType', w0,
                    'SuccessData', w2,
                    'SuccessDataContainer', w1,
                    'FollowUp', w1,
                    'IsSendWa', w3,
                    'accWa', w4,
                    'toWa', w2,
                    'IsSendMail', w3,
                    'accMail', w4,
                    'toMail', w2,
                    'IsSendURL', w3,
                    'DataSendURL', w2,
                    'ShowLabel', w3,
                    'ShowCaptcha', w3,
                    'ShowCoupon', w3,
                    'Up', w5,
                    'UpBy', w4
                ]);
            }
        }
    }
}
